import { render, staticRenderFns } from "./RequestAccessCode.vue?vue&type=template&id=17b85301&scoped=true&"
import script from "./RequestAccessCode.vue?vue&type=script&lang=js&"
export * from "./RequestAccessCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b85301",
  null
  
)

export default component.exports